import { SerialisableModel } from '../Model';
export class SegmentModel extends SerialisableModel {
    static from(data) {
        return new SegmentModel(data);
    }
    get brand() {
        return this.data.brand;
    }
    /* kept to be backwards compatible, the value was renamed in the payload */
    get category() {
        return this.data.business_category;
    }
    get businessCategory() {
        return this.data.business_category;
    }
    get entityId() {
        return this.data.entity_id;
    }
    get id() {
        return this.data.id;
    }
    /* kept to be backwards compatible, isActive was removed from payload and replaced with a status string*/
    get isActive() {
        return this.data.status ? this.data.status.toLowerCase() === 'active' : false;
    }
    get status() {
        return this.data.status;
    }
    get name() {
        return this.data.name;
    }
    get processingChannelIds() {
        return this.data.processing_channel_ids;
    }
    get dimensionHash() {
        return this.data.dimension_hash;
    }
}
